import "components/ThreadBookingDetails.scss";

import Alert from "components/Alert";
import { BookingTitle } from "components/booking_details/BookingTitle";
import BookingOrPropertyNotes from "components/BookingOrPropertyNotes";
import HostPreferences from "components/HostPreferences";
import Loading from "components/Loading";
import PropertyInfo from "components/PropertyInfo";
import { useParams } from "react-router-dom";
import Conversation from "scenes/thread/components/Conversation";
import HostInstructions from "scenes/thread/components/HostInstructions";

import { MultiplatBookingDetails } from "./MultiplatBookingDetails";
import { MultiplatMessenger } from "./MultiplatMessenger";
import { useMultiplatData } from "./useMultiplatData";

export const Multiplat = () => {
  const { guestEmail, conversationId } = useParams();

  const {
    select: { property, bookings, reservation, conversation },
    isLoading,
    error,
    refetchConversation,
    refetchBookings
  } = useMultiplatData(guestEmail, conversationId);

  if (isLoading) {
    return <Loading message={"Loading information for multiplat message..."} />;
  }

  if (error) {
    return (
      <Alert
        title="Something went wrong..."
        message="Please try refreshing the page."
        status="fail"
        type="block"
      />
    );
  }

  return (
    <div className="BookingDetails Thread" data-testid="booking-details">
      <BookingTitle thread={conversation} property={property} isMultiplat />
      {bookings?.map(booking => (
        <MultiplatBookingDetails
          key={booking?.id}
          property={property}
          booking={booking}
          reservation={reservation}
          refetchBookings={refetchBookings}
        />
      ))}

      <div>
        <div
          className="instructions-verification-tasks"
          data-testid="property-info"
        >
          <HostInstructions property={property} />
        </div>
        <PropertyInfo property={property} />
        <HostPreferences property={property} />
        <BookingOrPropertyNotes bookingOrProperty={property} type="property" />
      </div>

      <Conversation
        thread={conversation}
        reservation={reservation}
        booking={bookings?.[0]}
      />

      <MultiplatMessenger
        booking={bookings?.[0]}
        guestName={bookings?.[0]?.guest_name}
        property={property}
        thread={conversation}
        channel="guesty"
        update={refetchConversation}
      />
    </div>
  );
};
